export function SyncMyobCompanyFileCtrl ($scope, $uibModalInstance, workshopAPI, messages, company) {
  $scope.actions = $uibModalInstance;
  $scope.company = company;

  $scope.confirm = function () {
    workshopAPI.get('/workshop_admin/reset_myob_before_date', [$scope.company.id, $scope.date]).then(data => {
      console.log(data);
    }).catch(err => {
      messages.error(err);
    });
  };
}